/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { parse, stringify } from 'zipson';
import { Names } from './storeName';

// ppt与大纲交互状态管理
export const useStore = defineStore(Names.SLIDE, {
  state: () => ({
    isDisabled: false, // 菜单项是否不可点击
    isExpand: false, // 菜单项是否展开
  }),

  persist: {
    key: 'ai-ppt-store_slide',
    storage: sessionStorage,
    paths: [
      'isExpand',
    ],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },

  getters: {
    getDisabled: (state) => state.isDisabled,
    getExpand: (state) => state.isExpand,
  },

  actions: {
    changeDisabled(value) {
      this.isDisabled = value;
    },
    changeExpand(value) {
      this.isExpand = value;
    },
  },
})
